export const CorrespondenceEnv = (env: string) => {
  switch (env.toUpperCase()) {
    case "BAS":
      return "Bac à sable";
    case "EID":
      return "EID";
    case "PROD":
      return "Production";
    default:
      return undefined;
  }
};
